import { UsageModalForm } from './UsageModalForm';

interface UsageModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const UsageModal = ({ isOpen, onClose }: UsageModalProps) => {
	if (!isOpen) {
		return null;
	}

	return (
		<UsageModalForm
			isOpen={isOpen}
			onClose={onClose}
		/>
	);
};
